import React from 'react'

function About() {
  return (
    <div className=''>
      About
    </div>
  )
}

export default About
